var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#6d4096"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 8.4H14.6L14.24 17.4H13.16L12.8 8.4ZM12.71 20.28C12.71 20.004 12.806 19.77 12.998 19.578C13.202 19.386 13.436 19.29 13.7 19.29C13.976 19.29 14.21 19.386 14.402 19.578C14.594 19.77 14.69 20.004 14.69 20.28C14.69 20.544 14.594 20.778 14.402 20.982C14.21 21.174 13.976 21.27 13.7 21.27C13.436 21.27 13.202 21.174 12.998 20.982C12.806 20.778 12.71 20.544 12.71 20.28Z",
    fill: "#6d4096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5556a4eaea54f1582ad48a1e5aaf266f.svg";
export { ForwardRef as ReactComponent };